import React, { useEffect, useState, useRef } from 'react'
import { useExclusiveMenu } from '../../hooks/useExclusiveMenu'
import FormControl from '@mui/material/FormControl'
import Select, { SingleValue } from 'react-select'
import { SelectChangeEvent } from '@mui/material/Select'
import { TypeAction, TypeActionTranslations } from '../../utils/constants'
import { useTranslation } from 'react-i18next'
import '../../i18n'
import { incyiaSelectStyles } from '../../utils/incyiaSelectStyles'

interface SelectTypeActionsProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void
  /** Hide floating label when a parent FormField already shows one. */
  hideLabel?: boolean
}

const SelectTypeAction: React.FC<SelectTypeActionsProps> = ({
  value,
  onChange,
  hideLabel = true,
}) => {
  const menu = useExclusiveMenu()
  const [TypeActions, setTypeActions] = useState<string[]>([])
  const { t } = useTranslation()

  const containerRef = useRef<HTMLDivElement | null>(null)


  useEffect(() => {
    setTypeActions(TypeAction)
  }, [])

  const options = TypeActions.map((typeAction) => ({
    value: typeAction,
    label: t(TypeActionTranslations[typeAction]),
  }))

  const selectedOption = options.find((o) => o.value === value) || null

  const handleSelectChange = (
    selected: SingleValue<{ value: string; label: string }>
  ) => {
    onChange(
      {
        target: { name: 'TypeAction', value: selected ? selected.value : '' },
      } as SelectChangeEvent<string>,
      null
    )
  }

  return (
    <div ref={containerRef} style={{ width: '100%', position: 'relative' }}>
      {!hideLabel ? (
        <label
          style={{
            position: 'absolute',
            top: '-8px',
            left: '12px',
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.6)',
            backgroundColor: 'white',
            padding: '0 4px',
            zIndex: 60,
          }}
        >
          {t('actionCreate.sections.planning.type', {
            defaultValue: 'Task type',
          })}
        </label>
      ) : null}
      <FormControl fullWidth style={{ width: '100%' }}>
        <Select
          value={selectedOption}
          onChange={handleSelectChange}
          options={options}
          placeholder={t('actionCreate.sections.planning.type', {
            defaultValue: 'Task type',
          })}
          {...menu}
          styles={incyiaSelectStyles}
          isMulti={false}
        />
      </FormControl>
    </div>
  )
}

export default SelectTypeAction
